import logo from './logo.svg';
import './App.css';
import RoutesMoviSoftware from './components/Routes/RoutesMoviSoftware';
import { BrowserRouter } from "react-router-dom";
function App() {
  return (
    <BrowserRouter>
     <RoutesMoviSoftware />
    </BrowserRouter>
   
  );
}

export default App;
